module.exports = __webpack_public_path__ + "img/chat_type3.881b6a54.png";